import APIClient from '@/shared/http/clients/api'

const resourceName = 'campanhalistacontato'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetAllBySegmentationPaging = (campanhalistaId, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/campanhalista/${campanhalistaId}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Import = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/importar/`, data, config)

const CampaignListContactRepository = {
  GetAll,
  GetAllPaging,
  GetAllBySegmentationPaging,
  GetById,
  Create,
  Update,
  Delete,
  Import
}

export default CampaignListContactRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/configurations/campaignlistcontact.js